export const SET_BONUS = "SET_BONUS";
export const SET_BONUS_DELETE = "SET_BONUS_DELETE";